import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import { Box, Paper, Typography, Button } from "@mui/material";
import CockpitHome from "./CockpitHome/CockpitHome";
import CockpitLite from "./CockpitHome/CockpitLite";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../authConfig";
import { getDevSession } from "../utils/devSession";
import { loginStartPagina } from "../utils/veiligPad";

function MicrosoftIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 23 23"
      style={{ marginRight: '0.6rem', flexShrink: 0 }}
    >
      <rect x="0" y="0" width="11" height="11" fill="#f25022" />
      <rect x="12" y="0" width="11" height="11" fill="#7fba00" />
      <rect x="0" y="12" width="11" height="11" fill="#00a4ef" />
      <rect x="12" y="12" width="11" height="11" fill="#ffb900" />
    </svg>
  );
}

export function Home({ full = false }) {
  const { instance } = useMsal();

  function handleLogin() {
    instance.loginRedirect({
      ...loginRequest,
      redirectUri: process.env.REACT_APP_POPUP_REDIRECT_URI,
      // Na het inloggen terug naar de opgevraagde pagina (pad + query), alleen intern.
      redirectStartPage: loginStartPagina(),
    });
  }

  // Dev-login (test/lokaal) heeft geen MSAL-account: de templates hieronder zouden dan de
  // Microsoft-loginkaart tonen terwijl de rest van de app je wél als ingelogd ziet.
  if (getDevSession()) return full ? <CockpitHome /> : <CockpitLite />;

  return (
    <>
      <AuthenticatedTemplate>
        {full ? <CockpitHome /> : <CockpitLite />}
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <Box
          sx={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: '#f8f9fa',
          }}
        >
          <Paper
            elevation={0}
            sx={{
              maxWidth: 400,
              width: '100%',
              p: 5,
              mx: 2,
              textAlign: 'center',
              borderRadius: 3,
              border: '1px solid rgba(33, 45, 56, 0.08)',
              boxShadow: '0 4px 24px -4px rgba(33, 45, 56, 0.06)',
            }}
          >
            <Box sx={{ mb: 3 }}>
              <Box
                component="img"
                src={`${process.env.PUBLIC_URL}/favicon-192.png`}
                alt="Full Frame"
                sx={{ width: 48, height: 48, borderRadius: '0.75rem', objectFit: 'contain', mx: 'auto', mb: 2, display: 'block' }}
              />
              <Typography
                variant="h5"
                fontWeight={800}
                sx={{ mb: 0.5, letterSpacing: '-0.02em' }}
              >
                Full Frame
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Interne tools voor het team
              </Typography>
            </Box>

            <Button
              variant="contained"
              fullWidth
              onClick={handleLogin}
              sx={{
                py: 1.5,
                fontSize: '1rem',
                fontWeight: 600,
                textTransform: 'none',
                borderRadius: 2,
                bgcolor: '#526075',
                '&:hover': { bgcolor: '#237a77' },
                boxShadow: '0 4px 12px -2px rgba(42,143,139,0.3)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <MicrosoftIcon />
              Inloggen met Microsoft
            </Button>

            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ mt: 2.5, display: 'block' }}
            >
              Gebruik je @fullframe.nl account
            </Typography>
          </Paper>
        </Box>
      </UnauthenticatedTemplate>
    </>
  );
}
